"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const imgixUrlBuilder = require("imgix-url-builder");
const imgixLoader = (args) => {
  const url = new URL(args.src);
  const params = {
    fit: url.searchParams.get("fit") || "max",
    w: args.width,
    h: void 0
  };
  if (args.quality) {
    params.q = args.quality;
  }
  return imgixUrlBuilder.buildURL(args.src, params);
};
exports.imgixLoader = imgixLoader;
//# sourceMappingURL=imgixLoader.cjs.map
